/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { SinonimService } from '../../../controllers/Sinonim';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class SinonimCreateFormService extends YASAGPostFormService<__model.Sinonim> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      id: new FormControl({value: undefined, disabled: false}, []),
      sinonim_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      sinonim_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      sinonim_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      sinonim_fals: new FormControl({value: undefined, disabled: false}, []),
      residu: new FormControl({value: undefined, disabled: false}, [Validators.required]),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: SinonimService,
  ) {
    super('SinonimCreate', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.Sinonim> {
    const result = val => this.service.create(val);
    return this._submit('__model.Sinonim', result, 'null', value, false );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.Sinonim> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
